import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import Clickable from '@prisjakt/ui-clickable';
import CloseIcon from 'mdi-react/CloseCircleOutlineIcon';

export const AppliedFilters = styled.div`
  margin-top: ${layout.spacing.xSmall};

  ${media.largeUp`
  margin-top: 0;
`}
`;

export const AppliedFilter = styled(Clickable)`
  align-items: center;
  background: ${({ theme }) => theme.buttons.primary.bg};
  border-radius: ${layout.borderRadius};
  color: white;
  cursor: pointer;
  display: inline-flex;
  font-size: ${layout.measurements.fontSizeSmall};
  margin: 0 ${layout.spacing.xxSmall} ${layout.spacing.xxSmall} 0;
  max-width: 250px;
  padding: ${layout.spacing.xSmall};
  text-align: left;

  ${media.largeUp`
  font-size: ${layout.measurements.fontSizeSmall};
`}
`;

export const AppliedFilterText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const AppliedFilterIcon = styled(CloseIcon).attrs({ size: 14 })`
  flex: 0 0 auto;
  margin-left: ${layout.spacing.xxSmall};
`;

export const AppliedFiltersTitle = styled.span`
  margin-right: 1rem;
`;
